<template>
  <v-col cols="4" class="detail-view">
    <v-card>
      <v-list>
        <b>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Vertragsnummer</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-text="contract.number" />
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$page.props.user.permissions.offer.nwt_view">
            <v-list-item-content>
              <v-list-item-title>Debitor</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-select
                v-model="contract.offer.debitor_id"
                :items="contract.debitors"
                item-value="id"
                item-text="name"
                @change="updateDebitor"
              />
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Angebotsnummer</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-text="contract.offer.id" />
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                gewünschter Vertragsstart
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-if="!$page.props.user.permissions.offer.nwt_view" v-text="getDateString(contract.start_date_wanted)" />
              <v-menu
                v-if="$page.props.user.permissions.offer.nwt_view"
                v-model="menuStartDateWanted"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedStartDateWanted"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="contract.start_date_wanted"
                  no-title
                  scrollable
                >
                  <v-spacer />
                  <v-btn
                    text
                    color="primary"
                    @click="menuStartDateWanted = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="updateStartDateWanted"
                  >
                    Speichern
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                Vertragsbeginn
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-if="!$page.props.user.permissions.offer.nwt_view" v-text="getDateString(contract.start_date)" />
              <v-menu
                v-if="$page.props.user.permissions.offer.nwt_view"
                v-model="menuStartDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedStartDate"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="contract.start_date"
                  no-title
                  scrollable
                >
                  <v-spacer />
                  <v-btn
                    text
                    color="primary"
                    @click="menuStartDate = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="updateStartDate"
                  >
                    Speichern
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Vertragsende</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <div v-text="getDateString(contract.end_date)" />
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Gesamtlaufzeit</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <div v-text="contract.termData" />
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Restlaufzeit ab heute</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <div v-text="contract.remaining" />
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$page.props.user.permissions.offer.nwt_view">
            <v-list-item-content>
              <v-list-item-title>Gesamtumsatz</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <div style="text-decoration-line: underline; text-decoration-style: double; height: 18px;" v-text="moneyFormatter.format(contract.turnoverTotal.sum)" />
            </v-list-item-content>
          </v-list-item>
        </b>
        <br>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title>Endkunde</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>
              <LinkCustomer :company="contract.offer.get_data.orderer.company" />
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ contract.offer.get_data.orderer.branches[0].address.street }}
              {{ contract.offer.get_data.orderer.branches[0].address.house_number }},
              {{ contract.offer.get_data.orderer.branches[0].address.zip }}
              {{ contract.offer.get_data.orderer.branches[0].address.city }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Ansprechpartner:
              {{ contract.offer.get_data.orderer.first_name }}
              {{ contract.offer.get_data.orderer.last_name }}
            </v-list-item-subtitle>

            <v-list-item-subtitle
              v-if="contract.offer.get_data.orderer.email"
            >
              E-Mail: {{ contract.offer.get_data.orderer.email.email }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-if="contract.offer.get_data.orderer.phone_number"
            >
              Tel.: {{ contract.offer.get_data.orderer.phone_number.number }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <br>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title>Zuständiger VB</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>
              {{ contract.offer.get_data.performer.company.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ contract.offer.get_data.performer.first_name }}
              {{ contract.offer.get_data.performer.last_name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-if="contract.offer.get_data.performer.user.email"
            >
              E-Mail: {{ contract.offer.get_data.performer.user.email }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-if="contract.offer.get_data.performer.user.phone_number_1 && contract.offer.get_data.performer.user.phone_number_1 != 'NULL'"
            >
              Tel.: {{ contract.offer.get_data.performer.user.phone_number_1 }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <br>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title>Vertriebsteam</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title v-if="userVb?.team">
              {{ userVb?.team?.name }}
            </v-list-item-title>

            <v-list-item-subtitle v-if="userVb?.team?.teamleiter">
              Teamleiter:
              {{ userVb?.team?.teamleiter?.name }}
            </v-list-item-subtitle>

            <v-list-item-subtitle
              v-if="userVb?.team?.teamleiter?.email"
            >
              E-Mail: {{ userVb?.team?.teamleiter?.email }}
            </v-list-item-subtitle>

            <v-list-item-subtitle
              v-if="userVb?.team?.teamleiter?.phone_number_1 && userVb?.team?.teamleiter?.phone_number_1 != 'NULL'"
            >
              Tel.: {{ userVb?.team?.teamleiter?.phone_number_1 }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <br>
        <v-list-item one-line>
          <v-list-item-content>
            <v-list-item-title>Fragebogen</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="questionnaire">
            <a :href="route('questionnaire.create', [questionnaire.token, 0])">{{ route('questionnaire.create', [questionnaire.token, 0]) }}</a><br>
            <a :href="route('contract.userslist.csv', [contract])">Download Benutzerliste</a>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-btn class="primary" @click="createQuestionnaire">
              Fragebogen erstellen
            </v-btn>
          </v-list-item-content>
        </v-list-item>

        <v-list-item one-line>
          <v-list-item-content>
            <v-list-item-title>Adressen</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <a :href="route('contract.addresseslist.csv', [contract])">Download Liste</a>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Inhalt</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <ContentSnippet :offer-data="contract.offer.offer_data" />
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-row>
        <v-col cols="12">
          <v-divider />
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="commentForm.comment"
            label="Kommentar"
          />
          <v-col cols="12">
            <v-btn @click="updateComment">
              speichern
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import { formattedDateString } from '@/plugins/formatDate.js'
import ContentSnippet from '@/Components/Offers/Snippets/ContentSnippet'
import LinkCustomer from '@/Components/Customer/Snippets/LinkCustomer'

export default {
   components: {
      ContentSnippet,
      LinkCustomer
   },
   props: {
      questionnaire: {
         type: Object,
         required: false,
         default () { return {} }
      },
      contract: {
         type: Object,
         required: true
      },
      userVb: {
         type: Object,
         required: false,
         default () { return {} }
      },
   },
   data () {
      return {
         commentForm: this.$inertia.form(
            {
               comment: this.contract.offer.get_data.comment,
            }
         ),
         updateDatesManually: false,
         updateDateWantedManually: false,
         moneyFormatter: new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
         }),
         menuStartDate: false,
         menuStartDateWanted: false,
      }
   },
   computed: {
      computedStartDate () {
         return this.getDateString(this.contract.start_date)
      },
      computedStartDateWanted () {
         return this.getDateString(this.contract.start_date_wanted)
      },
   },
   methods: {

      createQuestionnaire () {
         this.$inertia.post(this.route('questionnaire.new', this.contract.id))
      },
      updateComment () {
         this.commentForm.patch(this.route('offerData.updateComment', this.contract.offer.get_data.id), {
            preserveScroll: true
         })
      },
      redirectToCustomer () {
         this.$inertia.visit(this.route('customer.show.uebersicht', {
            customer: this.contract.offer.get_data.orderer.company.id,
         }))
      },
      updateStartDate () {
         this.$inertia.post(
            this.route('contract.update.dates', { contract: this.contract.id }),
            { startDate: this.contract.start_date },
            { preserveScroll: true }

         )
         this.menuStartDate = false
      },
      updateStartDateWanted () {
         this.$inertia.post(
            this.route('contract.update.dates', { contract: this.contract.id }),
            { startDateWantend: this.contract.start_date_wanted },
            { preserveScroll: true }
         )
         this.menuStartDateWanted = false
      },

      updateDebitor () {
         this.$inertia.post(
            this.route('contract.update.debitor', {
               contract: this.contract.id
            }),
            {
               debitor_id: this.contract.offer.debitor_id,
            }
         )
      },
      getDateString (dateVal) {
         return formattedDateString(dateVal)
      },
   },

}
</script>

<style>
.detail-view .v-list-item__content {
    padding: 0px;
  }
  .detail-view  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  .detail-view  .v-list-item, .detail-view  .v-subheader {
    min-height: 24px;
  }
  .detail-view .v-text-field__details {
    display: none;
  }

</style>
